<template>
  <v-dialog
    v-model="dialogSilenciarProduto"
    width="700"
    content-class="bra-20"
    transition="dialog-top-transition"
    persistent
  >
    <v-card>
      <v-card-title class="py-4">
        <p class="ma-0">Silenciar notificação do produto</p>

        <v-spacer />

        <v-btn icon @click="fechar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-5">
        <v-radio-group
          class="dataradio"
          label="Silenciar o Produto Até*"
          hide-details
          v-model="dataradio"
          @change="addDate"
        >
          <v-row>
            <v-col col="2">
              <v-radio label="1 semana" value="7"></v-radio>
            </v-col>

            <v-col col="2">

              <v-radio label="1 mês" value="1"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="2 meses" value="2"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="3 meses" value="3"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="6 meses" value="6"></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>

        <v-menu
          ref="datepickerMenu"
          v-model="datepickerMenu"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="form.data"
              outlined
              v-mask="maskData"
              persistent-hint
              v-bind="attrs"
              v-on="on"
              :error-messages="dataErrors"
              @input="$v.form.data.$touch()"
              @blur="$v.form.data.$touch()"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="datepicker"
            no-title
            :min="today"
          />
        </v-menu>

        <v-autocomplete
          v-model="form.motivos"
          :items="motivos"
          class="autocomplete-motivo"
          item-value="id"
          item-text="descricao"
          label="Motivos de Silenciar o Produto"
          outlined
          chips
          small-chips
          multiple
          :error-messages="motivoErrors"
          @input="$v.form.motivos.$touch()"
          @blur="$v.form.motivos.$touch()"
        />

        <div class="pb-5" v-if="compra_por_filial_habilitada">
          <v-radio-group
            hide-details
            v-model="form.silenciar_em"
          >
            <v-radio value="somente_grupo">
              <template #label>
                <span class="pl-1">Silenciar somente {{filialCompra > 0 ? 'na filial' : 'no grupo'}}</span>
              </template>
            </v-radio>

            <v-radio value="filiais_grupo" class="mt-1">
              <template #label>
                <span class="pl-1">Silenciar em todas as filiais do grupo</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <div class="pl-1">
          <h4>Você pode silenciar o produto de 3 maneiras:</h4>

          <ul>
            <li>Por uma semana marcando a opção correspondente</li>
            <li>De 1 a 6 meses marcando a opção correspondente</li>
            <li>Informando uma data específica. Ex: 01/01/2021</li>
          </ul>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="SilenciarProdutos()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapMutations, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import moment from "moment";
import Fornecedor from "../../api/fornecedor";

export default {
  directives: { mask },
  data() {
    return {
      qtd_produtos: "",
      dataradio: "",
      form: {
        id: "",
        produtos: [],
        data: "",
        motivos: [],
        silenciar_em: 'somente_grupo'
      },
      count: 0,
      datepicker: "",
      datepickerMenu: false,
      maskData: {
        mask: "## / ## / ####",
        tokens: {
          "#": { pattern: /[0-9]/ },
        },
      },
      compra_por_filial_habilitada: localStorage.filial_compra === 'S'
    };
  },
  validations: {
    form: {
      data: {
        required() {
          let today = moment().format("YYYYMMDD");
          let data = moment(this.form.data, "DD / MM / YYYY").format(
            "YYYYMMDD"
          );
          if (data.length == 8 && data > today) return true;
          else return false;
        },
      },
      produtos: {
        required() {
          if (!this.produtoSilenciadoEditar || !this.produtoSilenciadoEditar.id) {
            return true;
          }

          return this.form.produtos && this.form.produtos.length > 0;
        }
      },
      motivos: { required },
    },
  },
  computed: {
    ...mapGetters("notificacaoProdutoSilenciado", ["produtoSilenciadoQtde"]),
    ...mapGetters({
      getFornecedor: "fornecedor/getFornecedor",
      comprador: "fornecedor/getComprador",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
    }),
    ...mapGetters("notificacaoProdutoSilenciado", [
      "produtoSilenciadoEditar",
      "motivos",
    ]),
    dialogSilenciarProduto: {
      get() {
        return this.$store.state.app.dialogSilenciarProduto;
      },
      set(val) {
        this.$store.commit("app/setDialogSilenciarProduto", val);
      },
    },
    dataErrors() {
      const errors = [];
      if (!this.$v.form.data.$dirty) return errors;
      !this.$v.form.data.required && errors.push("A data é invalida.");
      return errors;
    },
    motivoErrors() {
      const errors = [];
      if (!this.$v.form.motivos.$dirty) return errors;
      !this.$v.form.motivos.required && errors.push("O motivo é obrigatório.");
      return errors;
    },
    today() {
      return moment().toISOString();
    },
  },
  watch: {
    produtoSilenciadoEditar() {
      if (!this.produtoSilenciadoEditar) {
        return;
      } else if (this.produtoSilenciadoEditar.id > 0) {
        this.editar(this.produtoSilenciadoEditar);
      } else {
        this.abrir(this.produtoSilenciadoEditar);
      }
    },
    datepicker() {
      this.form.data = moment(this.datepicker).format("DD / MM / YYYY");
      this.dataradio = [];
    },
  },
  created() {
    this.$store.dispatch("notificacaoProdutoSilenciado/Motivo");
  },
  methods: {
    ...mapMutations("app", ["setDialogSilenciarProduto"]),
    ...mapMutations("notificacaoProdutoSilenciado", ["setProdutoSilenciadoEditar"]),

    SilenciarProdutos() {
      if (this.produtoSilenciadoEditar.silenciar_todo_fornecedor == true) {
        this.silenciarTodosProdutos()
      } else{
        this.salvar()
      }
    },

    silenciarTodosProdutos() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        data: moment(this.form.data, "DD / MM / YYYY").format("YYYY-MM-DD"),
        filial: this.filialCompra,
        fornecedor: this.getFornecedor.id,
        grupo: this.grupoCompra,
        motivos: this.form.motivos,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        silenciar_em: this.form.silenciar_em
      }
      this.$store.dispatch(
        // "notificacaoProdutoSilenciado/Store",
        "loading/addRequisicao",
        Fornecedor.getFornecedorSilenciar(headers, params)
        .then((response) => {
          const {token, qtd_produtos} = response.data;
          localStorage.setItem("token", token);
          this.$store.commit("notificacaoProdutoSilenciado/setProdutoSilenciadoQtde", qtd_produtos);
          this.fechar();
        })
      )
    },
    salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const params = {
        id: this.form.id,
        data: moment(this.form.data, "DD / MM / YYYY").format("YYYY-MM-DD"),
        produtos: this.form.produtos,
        motivos: this.form.motivos,
        filial: this.grupoCompra == 0 ? 0 : this.filialCompra,
        grupo: this.grupoCompra,
        fornecedor: this.getFornecedor.id,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        silenciar_em: this.form.silenciar_em
      };

      this.$store.dispatch("loadingAux/habilitarLoading", true);

      this.$store.dispatch("notificacaoProdutoSilenciado/Store", params)
        .then(() => this.fechar())
        .finally(() => this.$store.dispatch("loadingAux/habilitarLoading", false));
    },
    editar(item) {
      const params = { id: item.id };
      this.$store
        .dispatch("notificacaoProdutoSilenciado/Item", params)
        .then(({ data }) => {
          localStorage.setItem("token", data.token);
          this.form.data = moment(data.item.data_limite, "DD/MM/YYYY").format(
            "DD / MM / YYYY"
          );
          this.form.motivos = data.item.motivos.map((m) => m.id_motivo);
          this.form.id = data.item.id;
          item.id_grupo = item.grupo;
          this.abrir(item);
        });
    },
    abrir(item) {
      this.form.produtos = [];
      if (!item.produtos) {
        this.form.produtos.push({
          grupo: item.id_grupo,
          idproduto: item.idproduto,
        });
      } else {
        item.produtos.forEach((i) => {
          this.form.produtos.push({
            grupo: i.id_grupo,
            idproduto: i.idproduto,
          });
        });
      }
      this.setDialogSilenciarProduto(true);
    },
    fechar() {
      this.dataradio = "";
      this.form.id = "";
      this.form.data = "";
      this.form.produtos = [];
      this.form.motivos = [];
      this.form.silenciar_em = 'somente_grupo';
      this.$v.$reset();
      this.setProdutoSilenciadoEditar();
      this.setDialogSilenciarProduto(false);
    },
    addDate() {
      if (this.dataradio == 7) {
        this.form.data = moment()
          .add(this.dataradio, "days")
          .format("DD / MM / YYYY");
      } else {
        this.form.data = moment()
          .add(this.dataradio, "month")
          .format("DD / MM / YYYY");
      }
    },
  },
};
</script>

<style>
.v-autocomplete__content .v-list-item__action {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.dataradio {
  border: 1px solid rgb(158, 158, 158);
  border-bottom: 0;
  margin-bottom: 0px;
  border-radius: 4px;
  padding-bottom: 17px;
}
.dataradio .row {
  padding-top: 14px !important;
}
.dataradio legend {
  left: 9px !important;
  position: absolute !important;
  margin-top: -10px;
  background-color: #fff;
}
</style>
